import { TabStyles } from '@tableau/widgets';
import { NestedCSSProperties } from 'typestyle/lib/types';

import { CommonStyles } from '~common/react/CommonStyles';
import DataGridRowHeight = CommonStyles.Sizes.DataGridRowHeight;

export const revisionHistoryDialogPromptStyle: React.CSSProperties = {
  paddingBottom: TabStyles.Spacing.DefaultSpace,
  wordWrap: 'break-word'
};

export const revisionHistoryDialogGridContainerStyle: NestedCSSProperties = {
  position: 'relative',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: CommonStyles.Colors.BorderColor,
  $nest: { // this is a hack to add bottom border to the header row of data grid
    [`.tb-react-dg-body`]: {top: `${DataGridRowHeight + 2}px !important`},
    [`.tb-react-dg-hcol`]: {borderWidth: `0px !important`}
  }
};
